require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./architecture에-대해-고민해보자-클라이언트-편.json") })
        }
      }, "path---architecture에-대해-고민해보자-클라이언트-편");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---architecture에-대해-고민해보자-클라이언트-편!./.cache/json/architecture에-대해-고민해보자-클라이언트-편.json
// module id = 397
// module chunks = 231608221292675